module.exports = __webpack_public_path__ + "img/traffic-light.0240adeb.svg";